<template>
    <div>
        <div
            class="bg-img"
            :style="{
                'background-image': 'url(' + partnerImage + ')',
            }"
        ></div>
        <h1>{{ JSONParseTranslations(partner.title, locale.key) }}</h1>
        <h2>{{ JSONParseTranslations(partner.subtitle, locale.key) }}</h2>
        <div class="quick-actions">
            <q-btn
                size="16px"
                icon="eva-eye-outline"
                :to="{
                    name: 'PartnersDetails',
                    params: { partnerId: partner.id },
                }"
            >
                {{ $t('partners.see_partner') }}
            </q-btn>
            <q-btn
                v-if="partner.has_courses_button"
                size="16px"
                icon="eva-book-outline"
                :to="{
                    name: 'Courses',
                    params: {
                        partnerId: partner.id,
                    },
                }"
            >
                {{ $t('partners.see_courses') }}
            </q-btn>
        </div>
    </div>
</template>

<script>
import translate from '@/local-shared/mixins/translate'
import picturesService from '@/services/pictures'
import encoders from '@/helpers/encoders'
import store from '@/store'

export default {
    name: 'PartnerThumb',

    mixins: [translate],

    props: {
        partner: {
            type: Object,
            default: () => { },
        },
    },

    data() {
        return {
            partnerImage: '',
        }
    },

    computed: {
        locale() {
            return store.getters['locale/currentLocale']
        }
    },

    async created() {
        if (this.partner.partner_picture_id) {
            this.partnerImage = await this.fetchImage(this.partner.partner_picture_id)
        }
    },

    methods: {
        async fetchImage(pictureId) {
            let imageResponse = await picturesService.retrieveById(pictureId)

            if (imageResponse.status === 200) {
                return encoders.arrayBufferToBase64(imageResponse)
            } else {
                return '' //TODO: add a default image
            }
        },
    },
}
</script>